import { render } from "./Toolbar.vue?vue&type=template&id=2067b4f0&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=2067b4f0&scoped=true&lang=css"
import "./Toolbar.vue?vue&type=style&index=1&id=2067b4f0&lang=css"

import exportComponent from "/Users/Apple/Desktop/projects/guguop/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2067b4f0"]])

export default __exports__